<template>
  <div class="s-modal__wrapper s-modal__wrapper--white">
    <!-- Header -->
    <div class="s-modal__header s-modal__header--transparent">
      <button id="s-modal-close"
              type="button"
              class="s-modal__btn--close"
              data-dismiss="modal"
              aria-label="Close"
              @click="confirm"></button>
    </div>

    <!-- Main Content -->
    <div class="s-modal__body s-modal__body--start">
      <div class="s-modal__body s-modal__body--success">
        <div class="s-modal-content--etc" v-html="data.text"></div>
        <button v-if="data.btnText && data.btnFunc" @click="data.btnFunc" class="s-modal__btn--ws s-modal__btn--ws--single s-modal__btn--start">{{data.btnText}}</button>
        <span class="n-modal__thumb n-modal__thumb--sign"></span>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
      name: 'modalAlertTemplate',
      props : {
        data: {
          type: Object,
          default: function () {
            return {
              text: '유저 정보가 없습니다.',
              btnText: '',
              btnFunc: ''
            }
          }
        }
      },
      methods: {
        confirm() {
          window.close();
        }
      }
    }
</script>



// WEBPACK FOOTER //
// src/components/stage/modal/ModalPartialAlert.vue